import React from 'react'

export type TypewriterProps = {
  children?: string
}

export const Typewriter: React.FC<TypewriterProps> = ({ children }) => {
  const [index, setIndex] = React.useState(0)

  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => {
        if (prev + 1 === children?.length) {
          clearInterval(interval)
        }
        return prev + 1
      })
    }, 10)

    return () => clearInterval(interval)
  }, [children?.length])

  return children?.slice(0, index)
}
